import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Token } from 'src/app/models/token.model';
import { LoggedIn, LogoutSuccess } from '../actions/auth.actions';

export interface AuthStateModel {
  token: Token | null;
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    token: null,
  },
})
export class AuthState {
  @Selector()
  static getToken(state: AuthStateModel): Token | null {
    return state.token;
  }

  @Selector()
  static getUserRole(state: AuthStateModel): string | null {
    return state.token?.role || null;
  }

  @Action(LoggedIn)
  loggedIn(ctx: StateContext<AuthStateModel>, action: LoggedIn) {
    ctx.patchState({
      token: action.token,
    });
  }

  @Action(LogoutSuccess)
  logoutSuccess(ctx: StateContext<AuthStateModel>) {
    ctx.setState({
      token: null,
    });
  }
}
